import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  ClickAwayListener,
  Box,
} from "@mui/material";
import clsx from "clsx";
import * as maplayerAction from "../../../infofleet/ducks/maplayer";
import MapZoomIcon from "../../../assets/infofleet/mapzoom.png";

const ZOOM_VIEWS = [
  { key: "highway", label: "Highway View" },
  { key: "street", label: "Street View" },
  { key: "building", label: "Building View" },
  { key: "default", label: "Default View" },
];

function MapZoomLock({ maplayer }) {
  const dispatch = useDispatch();
  const mapzoomview = maplayer.MapZoomView;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggle = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (key) => {
    dispatch(maplayerAction.actions.MapZoomView(key));
    handleClose();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <Tooltip
          title={
            <Box fontSize={10} p={1}>
              <strong>Zoom Lock : </strong> 
             Lock the map zoom level to prevent automatic zoom changes after each map refresh.
            </Box>
          }
          arrow
          placement="bottom"
            slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#fff',
              color: '#000',
              fontSize: 14,
              borderRadius: 1,
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            },
          },
        }}
        >
          <IconButton
            size="small"
            onClick={handleToggle}
            sx={{
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              verticalAlign: "middle",
            }}
          >
            <img
              src={MapZoomIcon}
              alt="Map Zoom Lock"
              style={{
                width: 26,
                height: 26,
                display: "block",
               
              }}
            />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            style: {
              minWidth: 200,
              padding: "10px 0",
            },
          }}
        >
          {ZOOM_VIEWS.map(({ key, label }) => (
            <MenuItem
              key={key}
              selected={mapzoomview === key}
              onClick={() => handleSelect(key)}
              sx={{
                fontWeight: mapzoomview === key ? 600 : 400,
                color: mapzoomview === key ? "#007bff" : "#333",
                backgroundColor: mapzoomview === key ? "#e7f1ff" : "transparent",
                transition: "background-color 0.2s",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              className={clsx({ zoomlock_active: mapzoomview === key })}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </ClickAwayListener>
  );
}

const mapStateToProps = ({ maplayer }) => ({ maplayer });

export default connect(mapStateToProps)(MapZoomLock);
